import { render, staticRenderFns } from "./Sensors.vue?vue&type=template&id=2be31b4f&scoped=true&"
import script from "./Sensors.vue?vue&type=script&lang=js&"
export * from "./Sensors.vue?vue&type=script&lang=js&"
import style0 from "./Sensors.vue?vue&type=style&index=0&id=2be31b4f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be31b4f",
  null
  
)

export default component.exports